import axios from 'axios'

const REQUEST_TIMEOUT = 12000 // 12s — mobile networks are slower/flakier, fail fast and let the UI offer a retry

export const getApiBaseUrl = () => {
  if (import.meta.env.DEV) {
    return ''
  }
  return import.meta.env.VITE_API_URL || 'http://localhost:8000'
}

const api = axios.create({
  baseURL: getApiBaseUrl(),
  timeout: REQUEST_TIMEOUT,
})

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('mobile_access_token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('mobile_access_token')
      localStorage.removeItem('mobile_company_id')
      localStorage.removeItem('mobile_username')
      if (!window.location.pathname.startsWith('/login')) {
        window.location.href = '/login'
      }
    }
    return Promise.reject(error)
  }
)

// Classifies an axios error into a state the UI can render distinct copy/actions for
export const classifyApiError = (error) => {
  if (error.code === 'ECONNABORTED') return 'timeout'
  if (!navigator.onLine) return 'offline'
  if (!error.response) return 'network'
  if (error.response.status === 401) return 'unauthorized'
  return 'server'
}

export default api
